import React from 'react'
import './pcburn.css'
import Content from '../content'

function PCBURN() {
  return (
        <div class="wrapper bg-[#091c29]">
            <div class="candles">
                <div class="light__wave"></div>
                <div class="candle1">
                <div class="candle1__body">
                    <div class="candle1__eyes">
                    <span class="candle1__eyes-one"></span>
                    <span class="candle1__eyes-two"></span>
                    </div>
                    <div class="candle1__mouth"></div>
                    <img class=" translate-y-20  h-12 w-12"  src={Content.logo.img} alt=" logo"/>

                </div>
            
                </div>
                <div class="candle2">
                <div class="candle2__body">
                    <div class="candle2__eyes">
                    <div class="candle2__eyes-one"></div>
                    <div class="candle2__eyes-two"></div>
                    <div class="melow"> BUG</div>
                    </div>
                </div>
                </div>
                <div class="candle2__fire"></div>    
                <div class="sparkles-one"></div>
                <div class="sparkles-two"> </div>
                <div class="candle__smoke-one">
                </div>
                <div class="candle__smoke-two">
                </div>
            </div>
            <div class="floor  ">  </div>
            

        </div>
  )
}

export default PCBURN